import { Component } from '@angular/core';
import { AppMainComponent } from 'esz-saas-lcp-ng-crud-ui';


@Component({
  standalone: false,
  selector: 'app-ws-main',
  templateUrl: './ws-main.component.html',
  styleUrls: ['./ws-main.component.scss']
})
export class WsMainComponent extends AppMainComponent {

}
